export const EMAIl_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1,}(?:\.[a-zA-Z0-9-]{1,})*$/u;

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 4096;

export const STRING_MAX_LENGTH = 255;

export const INT_MAX_VALUE = 2147483647;

export const STRING_KANA_REGEX = /^\s*[ァ-ンヴー\s]+\s*$/u;

export const PHONE_NUMBER_REGEX = /^\s*\d{10,11}\s*$/u;

export const PHONE_DISPLAY_REGEX = /^(\d{2,3})(\d{4})(\d{4})$/;
